import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { request } from "utils/request";
import { useLoadingContext } from "app/contexts/LoadingContext";
import "./upgradePlanModal.css";
import { CheckLg } from "react-bootstrap-icons";

export default function UpgradePlanModal({ open, onClose }) {
  const [selectedPlan, setSelectedPlan] = useState("yearly");
  const { showMaskedLoading, hideMaskedLoading } = useLoadingContext();

  const handlePlanChange = (plan) => {
    setSelectedPlan(plan);
  };

  const handleStartFreeTrial = async () => {
    try {
      // Show masked loading while processing
      showMaskedLoading();

      const response = await request(
        `${process.env.REACT_APP_API_URL}/payments/checkout-session/`,
        {
          method: "POST",
          body: JSON.stringify({
            tier: "Solo",
            interval: selectedPlan,
            // coupon: "PROMO20",
            success_redirect_url: `${process.env.REACT_APP_URL}`,
            cancel_redirect_url: `${process.env.REACT_APP_URL}`,
          }),
        }
      );

      // Hide loading before redirect
      hideMaskedLoading();
      window.location.href = response.url; // redirect to the customer portal
      onClose();
    } catch (error) {
      // Hide loading on error
      hideMaskedLoading();
      // Error handled by component
    }
  };

  const handleClose = () => {
    // Hide any loading state when modal closes
    hideMaskedLoading();
    onClose();
  };

  // Cleanup loading state when modal is unmounted or closed
  useEffect(() => {
    if (!open) {
      hideMaskedLoading();
    }
  }, [open, hideMaskedLoading]);

  return (
    <Modal
      show={open}
      onHide={handleClose}
      centered
      className="upgrade-plan-modal-wrapper"
    >
      <Modal.Body className="p-0">
        <div className="upgrade-plan-modal">
          <div className="upgrade-plan-modal-header">
            <span>Upgrade to Solo Plan</span>
            <button className="upgrade-plan-modal-close" onClick={handleClose}>
              &times;
            </button>
          </div>
          <hr className="upgrade-plan-modal-divider" />
          <div className="upgrade-plan-modal-body">
            <div className="upgrade-plan-modal-desc">
              You're currently on the free plan.
              <br />
              Upgrade to enhance your inspection reports with AI.
            </div>
            <div className="upgrade-plan-modal-pricing">
              <div
                className={`upgrade-plan-modal-price${
                  selectedPlan === "monthly" ? " selected" : ""
                }`}
                onClick={() => handlePlanChange("monthly")}
              >
                <div className="price-main">
                  $29 <span className="price-unit">/month</span>
                </div>
                <div className="price-desc">Billed monthly</div>
              </div>
              <div
                className={`upgrade-plan-modal-price${
                  selectedPlan === "yearly" ? " selected" : ""
                }`}
                onClick={() => handlePlanChange("yearly")}
              >
                <span className="save-badge">Save ~17%</span>
                <div className="price-main">
                  $24.17 <span className="price-unit">/month</span>
                </div>
                <div className="price-desc">$290 billed annually</div>
              </div>
            </div>
            <div className="upgrade-plan-modal-desc">
              Everything in Free, plus: <br />
            </div>
            <ul className="upgrade-plan-modal-features">
              <li>
                <CheckLg /> Unlimited AI report generation
              </li>
              <li>
                <CheckLg /> Smart Template import
              </li>
              <li>
                <CheckLg /> Personalized AI Style
              </li>
              <li>
                <CheckLg /> 24/7 Online Client Booking
              </li>
              <li>
                <CheckLg /> Export Schedule to External Calendars
              </li>
              <li>
                <CheckLg /> Email and chat Support
              </li>
            </ul>
          </div>
          <hr className="upgrade-plan-modal-divider" />
          <div className="upgrade-plan-modal-footer ">
            <button
              className="upgrade-plan-modal-cta w-100"
              onClick={handleStartFreeTrial}
            >
              Start Free Trial ({selectedPlan === "monthly" ? "7" : "30"} days)
            </button>
            <div className="upgrade-plan-modal-cancel">
              Cancel anytime during trial period
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}
